var map = {
	"./01.svg": 15736,
	"./02.svg": 76228,
	"./03.svg": 98224,
	"./04.svg": 1172,
	"./05.svg": 41132,
	"./06.svg": 28861,
	"./07.svg": 23036,
	"./08.svg": 68140,
	"./09.svg": 76092,
	"./1.svg": 66448,
	"./10.svg": 21600,
	"./11.svg": 53940,
	"./12.svg": 73736,
	"./13.svg": 75716,
	"./14.svg": 90412,
	"./15.svg": 62988,
	"./16.svg": 70748,
	"./17.svg": 26680,
	"./18.svg": 16855,
	"./19.svg": 93472,
	"./2.svg": 30548,
	"./20 (copy).svg": 6976,
	"./20.svg": 22780,
	"./21.svg": 29788,
	"./22.svg": 57228,
	"./23.svg": 27288,
	"./24.svg": 81512,
	"./25.svg": 52448,
	"./26.svg": 73344,
	"./27.svg": 14528,
	"./28.svg": 964,
	"./29.svg": 39004,
	"./3.svg": 35744,
	"./30.svg": 23368,
	"./31.svg": 2084,
	"./32.svg": 47743,
	"./4.svg": 13992,
	"./5.svg": 48044,
	"./6.svg": 59396,
	"./7.svg": 39012,
	"./8.svg": 53288,
	"./9.svg": 91796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11292;